module.exports = __webpack_public_path__ + "img/resume.aca0eb75.svg";